import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import {
    borderRule,
    backgroundRule,
    blackBackgroundRule,
    borderRadiusRule,
    fontSizeRule,
    colorValue,
    COLOR_WHITE,
} from '../constants/cssRules'
import { ThemeVariants, ThemesNames } from '../constants'
import Icon from './Icon'

const StyledTag = styled.span`
    ${props => `
    display: inline-flex;
    line-height: 1;
    padding: 3px var(--rds-spacingSmall);
    transition: 0.4s transform, 0.4s opacity, 0.2s background-color, 0.2s padding;

    color: ${colorValue(props)};
    ${borderRule(props)}
    ${borderRadiusRule(props)}
    ${backgroundRule(props)}
    ${props.variant === ThemeVariants.DARK ? blackBackgroundRule(props) : ''}
    ${props.onClick ? 'cursor: pointer;' : ''}
    ${
        props.disabled
            ? `
        opacity: 0.5;
        cursor: not-allowed;
    `
            : 'opacity: 1;'
    }
    
    & .rds-tag_inner {
        font-weight: 600;
        ${fontSizeRule('12px')}
        width: max-content;
        color: ${
            props.variant === ThemeVariants.DARK ? 'white !important' : 'unset'
        };
    }
`}
`

const Tag = ({
    className,
    children,
    variant,
    style,
    onClick,
    title,
    disabled,
    icon,
}) => {
    const themeContext = useContext(ThemeContext)
    const processedClassName = `rds-tag ${className || ''} ${variant || ''}`

    const getIconVariant = () => {
        let iconVariant
        if (variant === ThemeVariants.DARK) {
            iconVariant = ThemeVariants.WHITE
        } else if (variant === ThemeVariants.TRANSPARENT || !variant) {
            iconVariant =
                themeContext.scheme === ThemesNames.DARK
                    ? ThemeVariants.WHITE
                    : variant
        } else {
            iconVariant = variant
        }
        return iconVariant
    }

    return (
        <StyledTag
            themeContext={themeContext}
            variant={variant}
            className={processedClassName}
            style={style}
            onClick={disabled ? undefined : onClick}
            title={title}
            disabled={disabled}
        >
            <span className='rds-tag_inner rds-flexbox align-center'>
                {icon ? (
                    <Icon
                        type={icon}
                        variant={getIconVariant()}
                        className={children ? 'rds-m_right__sm' : ''}
                    />
                ) : null}
                {children}
            </span>
        </StyledTag>
    )
}

export default React.memo(Tag)
